import { render, staticRenderFns } from "./comRegion2.vue?vue&type=template&id=0a0ee58f&"
import script from "./comRegion2.vue?vue&type=script&lang=ts&"
export * from "./comRegion2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports